import { createAction, props } from '@ngrx/store';
import { BillingItemV26, BillingitemPackageRequestV26 } from 'src/app/models-v26/billingitem-v26';
import { ActionResponse } from 'src/app/models/action-response';
import { AddServiceTopackageDueDatesV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/add-service-topackage-wizard/activation-step/addservices-due-date-info';
import { AddServiceTopackageInitStepV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/add-service-topackage-wizard/init-step/init-step';

export const selectInitStep = createAction(
  '[V26 Catalog Page] Select Init Add ServiceTopackage Information Step',
  props<{ initStep: AddServiceTopackageInitStepV26 }>(),
);

export const selectDueDatesStep = createAction(
  '[V26 Wizard Due Date Step] Select Add ServiceTopackage Due Date Step',
  props<{ dueDatesStep: AddServiceTopackageDueDatesV26 }>(),
);

export const selectServices = createAction(
  '[V26 Wizard Billing account Step] Select Add ServiceTopackage ServicePackage Step',
  props<{ servicesStep: BillingItemV26[] }>(),
);

export const exitAddServiceTopackageWizard = createAction('[V26 AddServiceTopackage Wizard Page] Exit Add ServiceTopackage Wizard');

export const destroyWizard = createAction('[V26 AddServiceTopackage Wizard Page] Destroy Wizard');

export const createNewAddServiceTopackage = createAction(
  '[V26 Wizard Confirmation Step] Create Add ServiceTopackage Information Step',
  props<{ request: BillingitemPackageRequestV26 }>(),
);

export const createNewAddServiceTopackageSuccess = createAction(
  '[V26 Wizard Confirmation Step] Create Add ServiceTopackage Information Step Success',
  props<{ response: ActionResponse }>(),
);

export const createNewAddServiceTopackageFail = createAction(
  '[V26 Wizard Confirmation Step] Create Add ServiceTopackage Information Step Fail',
  props<{ errorMessage: string }>(),
);
